// App.js
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import React, { lazy, useEffect, useState, createContext, useContext } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { themeChange } from "theme-change";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css'
import Layout from './components/Layout';
import AdminPage from './components/UserAdminComponnets/AdminPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', 
    },
    secondary: {
      main: '#dc004e', 
    },
  },
});

const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));

initializeApp();

export const AuthContext = createContext();
function App() {

  const handleCheckAuth = () => {
    const token = checkAuth();
    return !!token
  }
  const [isAuthenticated, setIsAuthenticated] = useState(handleCheckAuth || false);
  const queryClient = new QueryClient()

  useEffect(() => {
    themeChange(false);
    const token = checkAuth();

    setIsAuthenticated(!!token);
  }, []);

  return (
    // <ThemeProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/Admin" element={<AdminPage />} />
            <Route
              path="/dashbord"
              element={<Layout/>}
            />

            <Route path="/app/*" element={<Layout />} />
            <Route path="*" element={<Navigate to={"/app/welcome"} replace />} />
          </Routes>
        </Router>
      </AuthContext.Provider>
    </QueryClientProvider>
    // </ThemeProvider>
  );
}

export default App;
